import React from "react";
import FlaskEmptyOutline from "mdi-material-ui/FlaskEmptyOutline";

export default function DataScienceOutline(props) {
  return <FlaskEmptyOutline {...props} />;
}
